import storage from 'proxy-storage';
import getHCStorage from './getHCStorage';

/**
 * @public
 * Stores the contact object in the `hc` storage
 *
 * @param  {Object} contactData - object with the contact data
 */
export default function storeContactData({
  address,
  emailAddress,
  firstName,
  isMobile,
  lastName,
  phoneHome,
}) {
  const hcStorage = getHCStorage();
  if (address) {
    hcStorage.contact.address = address;
  }
  if (emailAddress) {
    hcStorage.contact.email_address = emailAddress;
  }
  if (firstName) {
    hcStorage.contact.first_name = firstName;
  }
  if (isMobile) {
    hcStorage.contact.is_mobile = isMobile;
  }
  if (lastName) {
    hcStorage.contact.last_name = lastName;
  }
  if (phoneHome) {
    hcStorage.contact.phone_home = phoneHome;
  }
  storage.setItem('hc', hcStorage);
}
